import { render, staticRenderFns } from "./Quickview.vue?vue&type=template&id=ef1c07f4&scoped=true"
import script from "./Quickview.vue?vue&type=script&lang=js"
export * from "./Quickview.vue?vue&type=script&lang=js"
import style0 from "./Quickview.vue?vue&type=style&index=0&id=ef1c07f4&prod&lang=scss"
import style1 from "./Quickview.vue?vue&type=style&index=1&id=ef1c07f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c07f4",
  null
  
)

export default component.exports